export default {
  getCompletedChecklist: (state) => state.completedChecklist,
};
